module.exports = __webpack_public_path__ + "img/t_severbig.19a6d5c7.png";